import Summary from "../../Uassist/USmartForms/Summary"

const SummaryView = () => {
  return (
    <>
      <Summary />
    </>
  )
}

export default SummaryView
